var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextpadheader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -71.8008 96.09 73.1914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2168 0.390625L73.877 0.390625C82.2266 0.390625 86.3281-3.71094 86.3281-11.9141L86.3281-58.4961C86.3281-66.6992 82.2266-70.8008 73.877-70.8008L22.2168-70.8008C13.916-70.8008 9.76562-66.6992 9.76562-58.4961L9.76562-11.9141C9.76562-3.71094 13.916 0.390625 22.2168 0.390625ZM21.5332-6.68945C18.5059-6.68945 16.7969-8.30078 16.7969-11.4746L16.7969-48.1934C16.7969-51.3672 18.5059-52.9785 21.5332-52.9785L74.5117-52.9785C77.5391-52.9785 79.2969-51.3672 79.2969-48.1934L79.2969-11.4746C79.2969-8.30078 77.5391-6.68945 74.5117-6.68945Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4668-38.5742L67.6758-38.5742C69.1895-38.5742 70.3125-39.7461 70.3125-41.2598C70.3125-42.7246 69.1895-43.8477 67.6758-43.8477L28.4668-43.8477C26.9043-43.8477 25.7812-42.7246 25.7812-41.2598C25.7812-39.7461 26.9043-38.5742 28.4668-38.5742Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4668-27.1973L67.6758-27.1973C69.1895-27.1973 70.3125-28.3203 70.3125-29.7852C70.3125-31.2988 69.1895-32.4707 67.6758-32.4707L28.4668-32.4707C26.9043-32.4707 25.7812-31.2988 25.7812-29.7852C25.7812-28.3203 26.9043-27.1973 28.4668-27.1973Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4668-15.8203L53.0273-15.8203C54.541-15.8203 55.6641-16.9434 55.6641-18.4082C55.6641-19.9219 54.541-21.0938 53.0273-21.0938L28.4668-21.0938C26.9043-21.0938 25.7812-19.9219 25.7812-18.4082C25.7812-16.9434 26.9043-15.8203 28.4668-15.8203Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextpadheader);
export default __webpack_public_path__ + "static/media/text.pad.header.1de49d3f046390321921bfe4dc655aa5.svg";
export { ForwardRef as ReactComponent };